module.exports = __webpack_public_path__ + "static/goffer-hex-light-3bc34ebc1250f8a8db3c350f069ba97f.png";